import classNames from 'classnames';

import { HeaderBg, HeaderContent, Heading, Subheading, Wrapper } from './Header.styles';

export const INTENT = {
  NOTSURE: 'NotSure',
  SELL: 'Sell',
  TRADE: 'TradeIn'
} as const;

type HeaderBaseProps = {
  error?: boolean;
  forceHeaderLineBreak?: boolean;
  forceSubheaderLineBreak?: boolean;
  headingCopy: string;
  lowValue?: boolean;
  subheadingCopy: string;
};

const HeaderBase = ({
  error,
  forceHeaderLineBreak,
  forceSubheaderLineBreak,
  headingCopy,
  lowValue,
  subheadingCopy
}: HeaderBaseProps) => (
  <Wrapper>
    <HeaderBg className={classNames({ error })}>
      <HeaderContent className={classNames({ forceHeaderLineBreak })}>
        <Heading className={classNames({ error })}>{headingCopy}</Heading>
        <Subheading className={classNames({ forceSubheaderLineBreak, lowValue })}>
          {subheadingCopy}
        </Subheading>
      </HeaderContent>
    </HeaderBg>
  </Wrapper>
);

export default HeaderBase;
